import {Field, FIELD_NAMES, FIELD_VALUES} from '@/api/models/Feeds.ts';
import {Button, MenuItem} from '@blueprintjs/core';
import {ItemRenderer, Select} from '@blueprintjs/select';
import {ReactElement, useCallback} from 'react';

export interface SchemaFieldSelectProps {
	value: Field | null,
	onSelect: (field: Field) => void,
}

export function SchemaFieldSelect({value, onSelect}: SchemaFieldSelectProps): ReactElement {
	const renderItem: ItemRenderer<Field> = useCallback((field, {handleClick, handleFocus, modifiers}) => {
		if (!modifiers.matchesPredicate)
			return null;

		return (
			<MenuItem
				key={field}
				text={FIELD_NAMES[field]}
				active={modifiers.active}
				selected={field === value}
				roleStructure="listoption"
				onClick={handleClick}
				onFocus={handleFocus}
			/>
		);
	}, [value]);

	return (
		<Select
			items={FIELD_VALUES}
			itemRenderer={renderItem}
			onItemSelect={onSelect}
			itemPredicate={filterSchemaField}
			fill={true}
			popoverProps={{matchTargetWidth: true, placement: 'bottom-start'}}
		>
			<Button
				alignText="start"
				text={value ? FIELD_NAMES[value] : 'Select a schema field...'}
				fill={true}
				endIcon="chevron-down"
			/>
		</Select>
	);
}

export function filterSchemaField(query: string, field: Field): boolean {
	return FIELD_NAMES[field].toLowerCase().includes(query.toLowerCase());
}
